/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

export type QuestionnaireResponseStatus = typeof QuestionnaireResponseStatus[keyof typeof QuestionnaireResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionnaireResponseStatus = {
  'in-progress': 'in-progress',
  completed: 'completed',
  'entered-in-error': 'entered-in-error',
  stopped: 'stopped',
  editing: 'editing',
} as const;
